import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FastLaneTestingState } from '../../../../entities/model/redux/FastLaneTestingState';

export interface AbTestingState {
  fastLaneTesting?: FastLaneTestingState;
}

const initialState: AbTestingState = {
  fastLaneTesting: undefined
};

const abTestingSlice = createSlice({
  name: 'abTesting',
  initialState,
  reducers: {
    setFastLaneTesting(state, action: PayloadAction<FastLaneTestingState | undefined>) {
      state.fastLaneTesting = action.payload;
    }
  }
});

export const { setFastLaneTesting } = abTestingSlice.actions;

export default abTestingSlice.reducer;
